import { render, staticRenderFns } from "./MemberIcon.vue?vue&type=template&id=6adf7646&scoped=true&lang=pug"
import script from "./MemberIcon.vue?vue&type=script&lang=js"
export * from "./MemberIcon.vue?vue&type=script&lang=js"
import style0 from "./MemberIcon.vue?vue&type=style&index=0&id=6adf7646&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf7646",
  null
  
)

export default component.exports